import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestions } from "../../store/questionBank/action";
import DraggableCard from "./DraggableCard"; // Import the DraggableCard component import { fetchQuestions } from "../../helper/backend_helper";
import SimpleBar from "simplebar-react";

const AssessmentCardDisplay = ({
  setIsNewQuestion,
  selectedCardId,
  setSelectedCardId,
}) => {
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState({});

  const questions = useSelector((state) => state.QuestionBankReducer.questions);
  const question = useSelector((state) => state.QuestionBankReducer.question);

  useEffect(() => {
    dispatch(fetchQuestions());
  }, []);

  const toggleDropdown = (id) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  return (
    <div>
      <div className="search-box mb-3">
        <input
          type="text"
          placeholder="Search Question"
          className="form-control"
          style={{ border: "1px solid #d3d3d3" }}
        />
        <span className="mdi mdi-magnify search-icon"></span>
      </div>
      <SimpleBar style={{ maxHeight: "700px", overflowY: "auto" }}>
        <div className="pe-1">
          {questions
            .filter((question) => !question.isDeleted)
            .reverse()
            .map((question) => (
              <DraggableCard
                key={question.id}
                question={question}
                selectedCardId={selectedCardId}
                setSelectedCardId={setSelectedCardId}
                setIsNewQuestion={setIsNewQuestion}
                toggleDropdown={toggleDropdown}
                dropdownOpen={dropdownOpen}
              />
            ))}
        </div>
      </SimpleBar>
    </div>
  );
};

export default AssessmentCardDisplay;
